import wrap_cache from 'nllib/src/promise-helper/wrap_cache'
import refund_change_policy_get from '../../../data-service/haolv-default/consumer_t-tp-refund-change-policy_get'

export default refund_change_policy_get